<template>
    <div :class="customClass" v-show="addressEntitlementLength">
        <h6 class="font-weight-bold" v-show="addressEntitlement && $route.path==='/booking/history' ? true : false">{{ TEXTS.render(`ENTITLEMENT_TABLE_HISTORY_HEADER`) }}</h6>
        <p v-for="(entitlementPeriodList, groupName, i) in addressEntitlement" v-if="i === 0" :key="i" v-html="TEXTS.render(`ENTITLEMENT_TABLE_HISTORY_PERIOD_HEADER`, null, {
            entitlementStartDate : getFormattedDate(entitlementPeriodList.entitlementStartDate),
            entitlementEndDate : getFormattedDate(entitlementPeriodList.entitlementEndDate)
        })">
        </p>
        <div class="table-responsive">
            <div class="d-flex align-content-center justify-content-center" :style="{'height': (loading ? '50px' : '0') }">
                <loader-circle v-if="loading" :class="fetchLoadingClasses" />
            </div>
            <table v-if="addressEntitlement" class="table border table-entitlement">
                <thead class="thead-light">
                    <tr>
                        <th :style="customTableHeaderColorStyle" scope="col" class="p-1 pl-4 paragraph-reduced" width="30%" v-html="tableHeaders.firstCol"></th>
                        <th :style="customTableHeaderColorStyle" scope="col" class="p-1 pl-4 paragraph-reduced" v-html="tableHeaders.secondCol"></th>
                        <th :style="customTableHeaderColorStyle" scope="col" class="p-1 pl-4 paragraph-reduced" v-html="tableHeaders.thirdCol" v-if="!restrictEntitlementTable"></th>
                        <th :style="customTableHeaderColorStyle" scope="col" class="p-1 pl-4 paragraph-reduced" v-html="tableHeaders.fourthCol"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(entitlementList, i) in addressEntitlement" :key="i" v-if="!!entitlementList.entitlementsDisplay">
                        <td class="p-1 pl-4">{{entitlementList.entitlementGroupName || entitlementList.entitlementType}}</td>
                        <td class="p-1 pl-4">{{printEntitlmentCount((entitlementList.initialEntitlements) + (restrictEntitlementTable ? 0 
                        : entitlementList.entitlementsCredited))}}</td>
                        <td class="p-1 pl-4" v-if="!restrictEntitlementTable">{{printEntitlmentCount(entitlementList.entitlementsClaimed)}}</td>
                        <td class="p-1 pl-4">{{printEntitlmentCount(entitlementList.entitlementsRemaining)}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!--div class="d-inline text--orange"><u>View booking history</u></div-->
    </div>
</template>

<script>
    import LoaderCircle from './LoaderCircle';
    import DateFormattable from '../utils/DateFormattable'
    import EntitlementGroup from '../utils/EntitlementGroup';
    import Texts from '../utils/Texts'
    import ServerDateMixin from '../mixins/ServerDateMixin'
    import Helper from "../../helper";

    export default {
        mixins: [ServerDateMixin],
        props: {
            addressId: {
                type: Number
            },
            customClass: {
                type: String,
                default: 'container pt-4 mb-4 entitlementhistorytable ' + Helper.getPortalName()
            },
            customTableHeaderColorStyle: {
                type: String,
                default: ''
            }
        },
        components: {
            LoaderCircle
        },
        data() {
            return {
                fetchLoadingClasses: 'loading-circle fetch-favorite-loading loading-circle--show',
                currentPortal: Helper.getPortalName(),
                loading: true
            }
        },
        mounted() {
            this.onload();
        },
        computed:{
            TEXTS(){ 
                return Texts
            },
            entitlementGroups : function(){
                var entitlementGroups = this.$store.getters.GET_ENTITLEMENT_GROUP.list;
                return entitlementGroups.map(entitlementGroup => new EntitlementGroup(entitlementGroup))
            },
            addressEntitlement: function(){
                var activeAddressId = (this.addressId || this.$route.query.id);
                var entitlementArray = this.$store.getters.GET_ADDRESS_ENTITLEMENT.list
                var message = this.$store.getters.GET_ADDRESS_ENTITLEMENT.message
                if(entitlementArray.length != 0 && this.$store.getters.GET_ADDRESS_ENTITLEMENT.config.params.id == activeAddressId){    
                    this.loading = false;
                    
                    var period = []
                    entitlementArray.forEach(item => {
                        var dateFrom = this.$moment(item.entitlementStartDate).format('DD/MM/YYYY')
                        var dateTo = this.$moment(item.entitlementEndDate).format('DD/MM/YYYY')
                        var isDisplay = item.isDisplay;
                        var today = new Date();
                        var dateCheck = this.$moment(today).format('DD/MM/YYYY');
                        
                        var d1 = dateFrom.split("/");
                        var d2 = dateTo.split("/");
                        var c = dateCheck.split("/");

                        var from = new Date(d1[2], parseInt(d1[1])-1, d1[0]);  // -1 because months are from 0 to 11
                        var to   = new Date(d2[2], parseInt(d2[1])-1, d2[0]);
                        var check = new Date(c[2], parseInt(c[1])-1, c[0]);

                        //RP-1193-Hide-entire-entitlement-section
                        //check Entitlement is Display or not 
                        if(check >= from && check <= to && isDisplay == true){
                            period.push(item)
                        }
                    })

                    var entitlementObject = this.groupEntitlementBy(period, 'groupName');
                    // Apply Names
                    if(this.entitlementGroups && entitlementObject){
                        for (const key in entitlementObject) {
                            if (entitlementObject.hasOwnProperty(key)) {
                                var entitlement = entitlementObject[key];
                                var entitlementGroup = this.entitlementGroups.find(entitlementGroup => {
                                    return entitlementGroup.api_value == entitlement.entitlementType
                                })
                                if(entitlementGroup){
                                    entitlementObject[key].entitlementGroupName = entitlementGroup.entitlement_group_name
                                }
                            }
                        }
                    }

                    return entitlementObject
                }
                else if(entitlementArray.length === 0 && message != null){
                    this.loading = false;
                    return null
                }
            },
            siteWordings() {
                return this.$store.getters['GET_SITE_WORDINGS']; 
            },
            tableHeaders(){
                const firstCol = this.siteWordings ? this.siteWordings.entitlement_h1 : null,
                secondCol = this.siteWordings ? this.siteWordings.entitlement_h2 : null,
                thirdCol = this.siteWordings ? this.siteWordings.entitlement_h3 : null,
                fourthCol = this.siteWordings ? this.siteWordings.entitlement_h4 : null

                return {
                    firstCol : firstCol || Texts.render(`ENTITLEMENT_TABLE_FIRST_COL`), 
                    secondCol : secondCol || Texts.render(`ENTITLEMENT_TABLE_SECOND_COL`), 
                    thirdCol : thirdCol || Texts.render(`ENTITLEMENT_TABLE_THIRD_COL`), 
                    fourthCol : fourthCol || Texts.render(`ENTITLEMENT_TABLE_FOURTH_COL`) 
                }  
            },
            addressEntitlementLength() {
                return Object.keys( (this.addressEntitlement || {}) ).length;
            },
            restrictEntitlementTable() {
                var setting = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_BOOKING_SETTING;
                var personalInfo = this.$store.getters.GET_PERSONAL_INFO;

                return !!setting.is_restrict_entitlement_table && personalInfo && personalInfo.type == 'resident';
            },
        },
        watch: {
            addressEntitlementLength: function(length) {
                this.$emit('dataCountRetrieved', length);
            }
        },
        methods: {
            onload() {
                this.$store.dispatch('getEntitlementGroup') ;
                // this.$store.dispatch('getSiteWordingsSettings');
                setTimeout(() => {
                    this.addressEntitlementSetting();
                }, 2000);
            },
            addressEntitlementSetting() {
                var activeAddressId = (this.addressId || this.$route.query.id);
                this.$store.dispatch('getAddressEntitlementV3', activeAddressId);
            },
            groupEntitlementBy(array, key){
                let sumsArray = {}
                array.forEach(item => {
                    var sums = sumsArray[item.entitlementType]
                    var initialEntitlements = parseInt(item.initialEntitlements)
                    var entitlementsCredited = parseInt(item.entitlementsCredited)
                    var entitlementsClaimed = parseInt(item.entitlementsClaimed)
                    var entitlementsRemaining = parseInt(item.entitlementsRemaining)
                    if (initialEntitlements || entitlementsRemaining || entitlementsCredited) {
                        if (sums) {
                            sums.initialEntitlements = initialEntitlements
                            sums.entitlementsCredited += entitlementsCredited
                            sums.entitlementsClaimed += entitlementsClaimed
                            sums.entitlementsRemaining += entitlementsRemaining
                        }else {
                            sumsArray[item.entitlementType] = {
                                entitlementType: item.entitlementType,
                                initialEntitlements: initialEntitlements,
                                entitlementsCredited: entitlementsCredited,
                                entitlementsClaimed: entitlementsClaimed,
                                entitlementsRemaining: entitlementsRemaining,
                                entitlementStartDate: item.entitlementStartDate,
                                entitlementEndDate: item.entitlementEndDate,
                                entitlementsDisplay: item.isDisplay
                            }
                        }
                    }
                })

                return sumsArray
            },
            printEntitlmentCount(count){
                try{
                    count = parseInt(count);
                    if(count >= 999){ 
                        return "Unlimited";
                    }
                }catch(err){

                };
                return count;
            },
            getFormattedDate(date){
                date = new DateFormattable(date || new Date())
                return date.formatDdMonYyyy()
            }
        }
    }
</script>